"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _of = require("rxjs/observable/of");

var _merge2 = require("rxjs/observable/merge");

var _interval = require("rxjs/observable/interval");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _switchMap = require("rxjs/operators/switchMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _share = require("rxjs/operators/share");

var _first = require("rxjs/operators/first");

var _mapTo = require("rxjs/operators/mapTo");

var _merge3 = require("rxjs/operators/merge");

var _takeUntil = require("rxjs/operators/takeUntil");

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _constants = require("./constants");

var _actions2 = require("settings-ui-sdk/ShopifyConnection/actions");

var POLLING_INTERVAL = 1000; // milliseconds

var poll$ = (0, _interval.interval)(POLLING_INTERVAL).pipe((0, _switchMap.switchMap)(function () {
  return (0, _fromPromise.fromPromise)(_API.default.getImportDetails()).pipe((0, _map.map)(_actions.FetchEcommerceImportDetails.success), (0, _catchError.catchError)(function (err) {
    return (0, _of.of)(_actions.FetchEcommerceImportDetails.failure(err));
  }));
}), (0, _share.share)());
var importComplete$ = poll$.pipe((0, _filter.filter)(function (_ref) {
  var payload = _ref.payload;
  return payload.data && payload.data.stage === _constants.ImportStages.COMPLETE;
}));
var importFailed$ = poll$.pipe((0, _filter.filter)(function (_ref2) {
  var payload = _ref2.payload;
  return payload.data && payload.data.stage === _constants.ImportStages.FAILED;
}));
var queryFailed$ = poll$.pipe((0, _filter.filter)(function (_ref3) {
  var payload = _ref3.payload;
  return !payload.data && payload.error && payload.error.status !== 404;
}));
var donePolling$ = (0, _merge2.merge)(importComplete$, importFailed$, queryFailed$).pipe((0, _first.first)(), (0, _share.share)());

var hasImport$ = function hasImport$(action$) {
  return action$.ofType(_actions.FetchEcommerceImportStatusActionTypes.SUCCESS).pipe((0, _filter.filter)(function (action) {
    return action.payload.data === _constants.ImportStatus.HAS_IMPORT;
  }));
};

var pollImportProgress = function pollImportProgress(action$) {
  return hasImport$(action$).pipe((0, _switchMap.switchMap)(function () {
    return poll$.pipe((0, _takeUntil.takeUntil)(donePolling$), (0, _merge3.merge)(donePolling$));
  }));
};

var pollUntilImportStarts = function pollUntilImportStarts(action$) {
  return action$.ofType(_actions2.ShopifyConnectionActionTypes.FINISH_SHOPIFY_CONNECTION).pipe((0, _switchMap.switchMap)(function () {
    return (0, _interval.interval)(POLLING_INTERVAL).pipe((0, _takeUntil.takeUntil)(hasImport$(action$)), (0, _mapTo.mapTo)((0, _actions.fetchEcommerceImportStatus)()));
  }));
};

var _default = (0, _reduxObservable.combineEpics)(pollImportProgress, pollUntilImportStarts);

exports.default = _default;
module.exports = exports.default;